import type { RouteRecordRaw } from 'vue-router'

// Componentes de autenticação
import LoginAmplify from '@/views/LoginAmplify.vue'
import Login from '@/views/Login.vue'

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: LoginAmplify,
    meta: { requiresGuest: true }
  },
  {
    path: '/login-amplify',
    name: 'LoginAmplify', 
    component: LoginAmplify,
    meta: { requiresGuest: true }
  }
]

export default authRoutes